import { Button } from 'primereact/button';
import styles from '../../stylesheets/productCard.module.css';
import redCrossIcon from '../../../../../assets/svgIcons/redCross.svg';

const ProductCard = ({ index, removeCard, watch }) => {
  const ctaType = watch('productCTAType');
  const customText = watch('productCTA.text');

  const previewLabel = ctaType === 'VIEW' ? 'View' : customText || 'Button Label...';

  return (
    <div className={styles.productCard}>
      {/* HEADER */}
      <div className={styles.productHeader}>
        <span className={styles.productTitle}>Card {index + 1}</span>

        {index !== 0 && (
          <img
            src={redCrossIcon}
            alt="Delete"
            className={styles.cardDelete}
            onClick={() => removeCard(index)}
          />
        )}
      </div>

      {/* PRODUCT INFO */}
      <div className={styles.productInfo}>
        <div className={styles.productInfoTitle}>
          Product Details · <span style={{ fontWeight: 500 }}>(Image, Title & Price)</span>{' '}
        </div>

        <div className={styles.productInfoSub}>
          ⓘ Pulled automatically from the selected catalog product
        </div>
      </div>

      {/* BUTTON PREVIEW */}
      <div className={styles.previewSection}>
        <div className={styles.productHeader}>
          <div className={styles.previewLabel}>Button Preview</div>
        </div>
        <div className={`${styles.previewBtn}`}>
          <p className={`${styles.previewBtnLabel}`}>{previewLabel}</p>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
